export const i18n = {
  defaultLocale: "de",
  locales: ["de", "en"],
} as const;

// TODO: this used to work until Next.js 15.5 broke it with their typed routes feature
export type Locale = string; //  (typeof i18n)["locales"][number];

export interface LanguageProps {
  lang: Locale;
}

export interface I18NPageProps {
  params: Promise<{
    lang: Locale;
  }>;
}
